export const fetch_mockups_by_category = (category_id) => {
	if (category_id === "all") {
		let url = global.config.server_path+'mockup/get';
		return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
		.then(resp => resp.json())
		.then(resp => validate_response(resp))
		.then(resp => Promise.resolve(resp.data))
		.catch(err => Promise.reject(err))
	} else {
		let url = global.config.server_path+'category/get_mockups';
		return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({category_id})})
		.then(resp => resp.json())
		.then(resp => validate_response(resp))
		.then(resp => Promise.resolve(resp.data))
		.catch(err => Promise.reject(err))
	}
}


export const fetch_mockups_by_category_paged = (category_id, page_no, size) => {
	if (category_id === "all") {
		let url = global.config.server_path+'mockup/get_mockups';
		return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({priority_sort: true, page_no : page_no, size : size})})
		.then(resp => resp.json())
		.then(resp => validate_response(resp))
		.then(resp => Promise.resolve(resp.data))
		.catch(err => Promise.reject(err))
	} else {
		let url = global.config.server_path+'mockup/get_mockups';
		return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({priority_sort: true, category_id : category_id, page_no : page_no, size: size})})
		.then(resp => resp.json())
		.then(resp => validate_response(resp))
		.then(resp => Promise.resolve(resp.data))
		.catch(err => Promise.reject(err))
	}
}

var validate_response = (response) => response.response_code===1?Promise.resolve(response):Promise.reject(response)